import React from 'react';

export const PanelLayoutContentWrapper = (props) => {
    const {className, children} = props;
    return (
        <div className="gui-editor-wrapper">
            <div className={"gui-editor-setup " + (className ? className : "")}>
                {children}
            </div>
        </div>
    )
}